import React, { useRef, useEffect, useState, useContext, useReducer, useCallback } from "react";
import dinoReducer from "../../reducerspwa/dinoReducer"
import DinoTable from "./dinotable"
import {DinoRadio} from "./dinoRadio"
import { loadDinoAction,loadRadioAction  } from "../../actionspwa/dinoActions";
import './dinoContainer.css';
import { SVVanillaNav } from "./SVVanillaNav";





export const CosmosContainer = () =>{

    let initialState = {
        loading: false,
        error: false,
        my_data: [
            {
                "name": "Bob",
                "age": 23,
                "species": "T. Rex"
            },
            {
                "name": "Dylan",
                "age": 44,
                "species": "Bracchio"
            },
            {
                "name": "Kate",
                "age": 32,
                "species": "Stego"
            },
            {
                "name": "Sally",
                "age": 13,
                "species": "T. Rex"
            }
        ]

    }

    const [{loading, error, my_data}, dispatch]= useReducer(dinoReducer, initialState);

    function changeRadioSV(o){
        console.log('sv*****81****changeRadio7');
        console.log(o);
        console.log('sv*****81****changeRadio..');
        for(let i=0; i < radio_data.length; i++){

            let current = radio_data[i];
            if(current.id === o.id){
                current.selected = true;
            }else{
                current.selected = false;

            }
        }
        console.log(radio_data)

    }

    const mapDispatchToProps = (dispatch) => ({
        refresh: () => {
            loadDinoAction(dispatch)
        }

    })

    const getDinoCB = useCallback(() => {
        console.log('Step 2 - reactses useCall back fired');
        loadDinoAction(dispatch);
    }, [dispatch]);

    const getRadioCB = useCallback((o) => {
        console.log('Step intermedia - react useCall back fired');
        console.log('sv*****81****changeRadio');
        console.log(o);
        console.log('sv*****81****changeRadio..');
        for(let i=0; i < radio_data.length; i++){

            let current = radio_data[i];
            if(current.id === o.id){
                current.selected = true;
            }else{
                current.selected = false;

            }
        }

        loadRadioAction(dispatch, radio_data);
    }, [dispatch]);


    useEffect(() => {
        console.log('Step 1 - uses effect will always be called by rf');
        getDinoCB(dispatch);
    }, [getDinoCB]);


    let radio_data= [
        {
            "name": "1",
            "id": 1,
            "selected": true,
            "age": 23,
            "species": "T. Rex"
        },
        {
            "name": "2",
            "id": 2,
            "selected": false,
            "age": 44,
            "species": "Bracchio"
        },
        {
            "name": "3",
            "id": 3,
            "selected": false,
            "age": 32,
            "species": "Stego"
        },
        {
            "name": "4",
            "id": 4,
            "selected": false,
            "age": 13,
            "species": "T. Rex"
        }
    ]
/*


    return (
        <div>
            
            <h3>Dinosaurs!</h3>
           
            <DinoRadio radio_data={radio_data} onChildClick={changeRadioSV}></DinoRadio>
            
        </div>
    )

*/

    return (

       
           
            <SVVanillaNav radio_data={radio_data} onChildClick={changeRadioSV}></SVVanillaNav>
            
       
    )

}